// Pusty edytor zapisuje np. „<p></p>" albo samą spację - taka treść nie może
// otwierać zakładki, która po kliknięciu nic nie pokazuje.
export const hasRichContent = (html) =>
  Boolean(html) &&
  (/<(iframe|img|video)\b/i.test(html) ||
    html
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim() !== '')
